import type { ZonesMapConfig } from '@chukua/common';
import { useEffect, useState } from 'react';
import { getZonesMapConfig } from '../zones.api';

/** Unreachable config draws what it can: no tiles, no company marker. */
const WITHOUT_MAP: ZonesMapConfig = { tileKey: null, company: null };

/**
 * What a zones map needs before it draws — the MapTiler key and the company it is centred on and marks:
 * `undefined` until the answer arrives (so the map shows a skeleton rather than a false "not configured").
 * Fetched once — neither changes while the page is open.
 */
export function useZonesMapConfig(): ZonesMapConfig | undefined {
  const [config, setConfig] = useState<ZonesMapConfig | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    getZonesMapConfig()
      .catch(() => WITHOUT_MAP)
      .then((loaded) => {
        if (!cancelled) setConfig(loaded);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}
